export default __webpack_public_path__ + "static/media/image-ph-health-statistics-m@3x.5259b9bd.png";